import React, { useContext, useEffect } from 'react'
import SessionContext from '../../context/SessionContex'
import CategoryItem from '../houses/CategoryItem'

function Categories() {
    const sessionCtx = useContext(SessionContext)
    const categories = sessionCtx.categories

    useEffect(() => { }, [categories])

    return (
        <div className='container mx-auto px-3 py-16'>
            <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6">
                <div className="max-w-4xl">
                    <div className="flex items-center gap-2 text-primary mb-4">
                    </div>
                    <h2 className="text-3xl font-headline font-black text-on-surface tracking-tighter mb-4">
                        Design For Every Project
                    </h2>
                    <p className="text-on-surface-variant font-medium leading-relaxed">
                        Explore our affordable architectural frameworks, engineered for strength and modern design.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
                {categories.map((category, idx) => (
                    <CategoryItem
                        key={idx}
                        category={category}
                    />
                ))}
            </div>
        </div>
    )
}

export default Categories